document.querySelectorAll(".wp-block-video").forEach(function (block) {
	const video = block.querySelector("video");
	const animation_allowed = window.matchMedia("(prefers-reduced-motion: no-preference)");

	if (animation_allowed.matches) {
		video.setAttribute("data-resume-scroll", "true");
	}

	// This automatically pauses the video when you scroll away
	if ("IntersectionObserver" in window || !!window.IntersectionObserver) {
		var videoObserver = new IntersectionObserver(
			function (elements, observer) {
				elements.forEach(function (element) {
					const video = element.target;
					if (element.isIntersecting) {
						if (video.paused && video.hasAttribute("data-resume-scroll")) {
							video.play();
							video.removeAttribute("data-resume-scroll");
						}
					} else {
						if (!video.paused) {
							video.setAttribute("data-resume-scroll", "true");
							video.pause();
						}
					}
				});
			},
			{ threshold: 0.75 }
		);
		videoObserver.observe(video);
	}
});
